import React, { useState, useEffect } from "react";
import VehiclesList from "../VehiclesList/VehiclesList";
import "./CompareTab.sass";
import modelsList from "../../SuzukiModelsList";
import SpecsList from "../SpecsList/SpecsList";
import {
  getModelSpecs,
  parseToKeyValuePairs,
  getThumbnailURL,
} from "./helpers";
import Baleno from "../../images/Baleno.png";
import Celerio from "../../images/Celerio.png";
import Ciaz from "../../images/Ciaz.png";
import Dzire from "../../images/Dzire.png";
import Ertiga from "../../images/Ertiga.png";
import Ignis from "../../images/Ignis.png";
import Jimny from "../../images/Jimny.png";
import S_Presso from "../../images/S-Presso.png";
import Super_Carry from "../../images/Super-Carry.png";
import Swift_Sport from "../../images/Swift-Sport.png";
import Swift from "../../images/Swift.png";
import Vitara from "../../images/Vitara.png";
import mouse from "../../images/loaf-mouse-1.svg";

const CompareTab = () => {
  const [displayingList, setDisplayingList] = useState(true);
  const [modelSpecs, setModelSpecs] = useState([]);
  const [thumb, setThumb] = useState(Baleno);
  const [price, setPrice] = useState("");
  const [mouseDisplay, setMouseDisplay] = useState("inline");

  const getPrice = () => {
    modelSpecs.forEach((item, index) => {
      if (item.key === "retail price") {
        let retailPrice = item.value.toString().split("");

        retailPrice.splice(3, 0, " ");

        console.log(retailPrice);

        setPrice(retailPrice.join(""));
      }
    });
  };

  const getImage = () => {
    modelSpecs.forEach((item, index) => {
      if (item.key === "model") {
        let imageTitle = item.value.split("-").join("_");
        imageTitle.split(" ").join("_");

        switch (imageTitle) {
          case "Baleno":
            setThumb(Baleno);
            break;
          case "Celerio":
            setThumb(Celerio);
            break;
          case "Ciaz":
            setThumb(Ciaz);
            break;
          case "Dzire":
            setThumb(Dzire);
            break;
          case "Ertiga":
            setThumb(Ertiga);
            break;
          case "Ignis":
            setThumb(Ignis);
            break;
          case "Jimny":
            setThumb(Jimny);
            break;
          case "S_Presso":
            setThumb(S_Presso);
            break;
          case "Super Carry":
            setThumb(Super_Carry);
            break;
          case "Swift Sport":
            setThumb(Swift_Sport);
            break;
          case "Swift":
            setThumb(Swift);
            break;
          case "Vitara":
            setThumb(Vitara);
            break;
          case "Vitara Brezza":
            setThumb(Vitara);
            break;
          default:
            return Baleno;
        }
      }
    });
  };

  useEffect(() => { });

  useEffect(() => {
    if (modelSpecs.length > 0) {
      setDisplayingList(false);
      getImage();
      getPrice();
    }
  }, [JSON.stringify(modelSpecs)]);

  const handleListItemClick = (model) => {
    console.log("List item clicked:", model);
    setMouseDisplay("none");

    getModelSpecs(model)
      .then((modelData) => {
        setModelSpecs(parseToKeyValuePairs(modelData));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="compare-tab">
      <img
        src={mouse}
        alt=""
        className="svg-mouse"
        style={{ display: mouseDisplay }}
      />
      {displayingList ? (
        <div className="compare-tab-wrapper">
          <h2 className="compare-tab-text-light compare-tab-header">
            Select a vehicle to compare
          </h2>
          <VehiclesList
            list={modelsList}
            handleListItemClick={handleListItemClick}
          />
        </div>
      ) : (
        <div className="model-specs-outer-wrapper">
          <div className="model-specs-image">
            {modelSpecs.length && (
              <img src={getThumbnailURL(modelSpecs)} alt="" />
            )}
          </div>
          <div className="model-specs-price">
            <h3>
              <span style={{ color: "#52A49A" }}>FROM </span>
              {`R${price}`}
            </h3>
          </div>
          <div
            className="choose-vehicle-button"
            onClick={() => {
              setDisplayingList(true);
            }}
          >
            <span>Choose another vehicle</span>
            <i className="fas fa-arrow-right fa-2x"></i>
          </div>
          <div className="model-specs-wrapper">
            <SpecsList data={modelSpecs} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CompareTab;
